<template>
  <div class="payment-options">
    <div class="header">
      <h2>Betaling</h2>
    </div>
    <div class="payment-options-grid">
      <u-radio-group
        name="gateways"
        :options="gatewayOptions"
        :value="selectedGateway"
        @change="SET_SELECTED_GATEWAY"
      />
      <div>
        <express-checkout-cart :namespace="namespace" />
      </div>
    </div>
    <p ref="apiError" v-if="apiErrors.user" class="api-error" v-html="apiErrors.user"></p>
  </div>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'
  import URadioGroup from './URadioGroup'
  import ExpressCheckoutCart from './ExpressCheckoutCart'

  export default {
    components: {
      URadioGroup,
      ExpressCheckoutCart
    },
    props: {
      namespace: {
        type: String,
        required: true
      }
    },
    computed: {
      gatewayOptions () {
        return this.gateways.map(gateway => {
          return {
            label: gateway.name,
            value: gateway.paymentMethod
          }
        })
      }
    },
    watch: {
      apiErrors (val) {
        if (Object.keys(val).length > 0) {
          this.$nextTick(() => {
            this.$refs.apiError.scrollIntoView({ behavior: 'smooth' })
          })
        }
      }
    },
    beforeCreate () {
      const namespace = this.$options.propsData.namespace
      const { mapState, mapGetters, mapMutations } = createNamespacedHelpers(namespace)
      // computed
      this.$options.computed = {
        ...(this.$options.computed || {}),
        ...mapState(['selectedGateway', 'apiErrors']),
        ...mapGetters(['gateways'])
      }
      // methods
      this.$options.methods = {
        ...(this.$options.methods || {}),
        ...mapMutations(['SET_SELECTED_GATEWAY'])
      }
    },
    created () {
      this.SET_SELECTED_GATEWAY(this.gateways[0].paymentMethod)
    }
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .payment-options {
    width: 100%;
    margin: 0 auto;
    padding: 0 1.5em 5em 1.5em;

    @include screen(md) {
      width: 8 / 10 * 100%;
      padding: 0 0 3em;
    }

  }

  .header {
    text-align: center;
    padding-bottom: 1.5em;

    @include screen(md) {
      padding-bottom: 2.5em;
    }

    h2 {
      font-size: 1.5em;
      line-height: 1.33;

      @include screen(md) {
        font-size: 1.75em;
        line-height: 1.2;
      }

    }

  }

  .payment-options-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 2em;
    grid-row-gap: 1.5em;

    @include screen(md) {
      grid-template-columns: 5fr 3fr;
    }

  }

  .api-error {
    color: var(--ec-red, red);
    margin-top: .5em;
  }

</style>
